<div class="sdds-row">
    <div class="sdds-col-max-3 sdds-col-xxlg-3 sdds-col-xlg-3 sdds-col-lg-3 sdds-col-md-5 sdds-col-sm-12 sdds-col-xs-12">
        <app-specification-browser></app-specification-browser>
    </div>
</div>